
export const parseEncodedRouteAndFoldSearchParams = (route: string, locationSearchParams: URLSearchParams) => {
  const [pathname, querystring] = decodeURIComponent(route).split('?')

  let search = ''
  // if route params then prioritize route params in front of others
  if (querystring) {
    const routeSearchParams = new URLSearchParams(querystring)

    for (const [name, value] of Array.from(new URLSearchParams(locationSearchParams).entries())) {
      routeSearchParams.append(name, value)
    }
    search = routeSearchParams.toString()
  }
  else search = locationSearchParams.toString()

  return {
    pathname,
    search,
  }
}